module.exports = "/_next/static/images/talents-35613fcea3709a2ceeb952c800393aba.png";